import React from "react";

export default function VehicleDescription({ vehicle }) {
  // Static placeholder text matching the design
  const placeholderText = `This 2021 Porsche 911 GT3 is finished in Shark Blue over a Black leather and Race-Tex interior. Power is provided by a 4.0-liter flat-six paired with a seven-speed PDK dual-clutch transaxle. Equipment includes the Chrono Package, a front-axle lift system, LED headlights in Black with PDLS+, carbon-fiber bucket seats, and Porsche Ceramic Composite Brakes (PCCB) with Yellow-painted calipers.

The car was delivered new to Porsche Los Angeles and shows just over 1,200 miles. A factory protective film was applied to the front end, mirrors, and rocker panels prior to delivery. This GT3 is now offered on dealer consignment with a clean Carfax report and a clean California title.`;
// Use vehicle description if available, otherwise show fallback text
 const description = vehicle?.description || "No vehicle details available.";

  return (
    <div className="bg-[#1e293b] rounded-lg border border-gray-700 p-6 shadow-md">
      {/* Section Header */}
      <div className="mb-4 pb-0">
        <h3 className="text-xl font-bold text-white flex items-center gap-3">
          <svg
            className="w-6 h-6 text-blue-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h7"
            />
          </svg>
          Description
        </h3>
      </div>

      {/* Description Content */}
      {/* <div className="text-gray-300 leading-7 text-sm md:text-[15px] font-light tracking-wide space-y-4">
        {placeholderText.split('\n\n').map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div> */}
      <div className="text-gray-300 leading-7 text-sm md:text-[15px] font-light tracking-wide space-y-4">
        {description.split("\n\n").map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
    </div>
  );
}
